
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./PrintCashbook.module.css"
import plus from "../../../Assets/plus.svg"
import ReportBackground from "../../../Assets/report.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";







const PrintCashbook = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [userType, setUserType] = useState('');
  const [provin, setProvin] = useState("");
  const [regio, setRegio] = useState("");
  const [contin, setContin] = useState("");
  const [usert, setUsert] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const userType = await localStorage.getItem('admin');
      const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');
      const usertype = await localStorage.getItem('userType');      
      if (value !== null) {
        setBearer(value);
      }
      if (userType !== null) {
        setUserType(userType);
      }
        if (provinceid !== null) {
        setProvin(provinceid);
      }
      if (continentid !== null) {
        setContin(continentid);
      }
      if (regionid !== null) {
        setRegio(regionid);
      }
      if (usertype !== null) {
        setUsert(usertype);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };







  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  const fetchAccounts = async () => {
    setSavingsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/reports/general-ledger-filter`, {
        params: {
          gl_code: selectedBank?.value || "",
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: usert == '2' ? contin : selectedContinent || "",
          region_id: usert == '3' ? regio : selectedRegion || "",
          province_id: usert == '4' ? provin : selectedProvince || ""
          // continent_id: usert == '2' ? selectedContinent : "",
          // region_id: usert == '3' ? selectedRegion : "",
          // province_id: usert == '4' ? selectedProvince : ""
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });

      if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
        setAccounts([]);   // ✅ clear previous data
        setNoData(true);
        return;
      }

      const resultsss = response.data?.data?.journal;
      const resultssx = response.data?.data?.input;

      setAccounts(resultsss);
      setInputss(resultssx);
      setNoData(false);

      console.log(resultsss);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.log(error);
        setAccounts([]);   // ✅ also clear here on error
        setNoData(true);
      }
    } finally {
      setSavingsLoading(false);
    }
  };





  const filteredAccounts = accounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.details?.toLowerCase().includes(term) ||
      item.cheque_number?.toLowerCase().includes(term) ||
      item.transaction_date?.toLowerCase().includes(term)
    );
  });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash-and-bank`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);





  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };


  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers });

      // console.log(response);
      const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSubContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (accounts) {
      const debitTotal = accounts?.reduce((total, item) => total + parseFloat(item.debit), 0);
      const creditTotal = accounts?.reduce((total, item) => total + parseFloat(item.credit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

  const tableRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

     const exportToExcel = async () => {
  const dataToExport = accounts; // Changed from inputss to accounts based on your UI
  const metaData = inputss; // Assuming inputss holds the date range objects

  if (!dataToExport || dataToExport.length === 0) {
    console.log("No data available to export");
    return;
  }

  // Calculate Totals for the Excel Footer
  const totalDebit = dataToExport.reduce((sum, item) => sum + (parseFloat(item.debit) || 0), 0);
  const totalCredit = dataToExport.reduce((sum, item) => sum + (parseFloat(item.credit) || 0), 0);
  const openingBal = parseFloat(dataToExport[0]?.opening_balance || 0);
  const closingBal = parseFloat(dataToExport[0]?.closing_balance || 0);

  // 1. Add Opening Balance Row
  const excelData = [
    {
      'Post Date': 'OPENING BALANCE',
      'Value Date': '',
      'Details': 'Brought Forward',
      'Debit': '',
      'Credit': openingBal
    }
  ];

  // 2. Map Transaction Rows
  dataToExport.forEach((item) => {
    excelData.push({
      'Post Date': item.created_at ? new Date(item.created_at).toLocaleDateString() : '-', // formatted date
      'Value Date': item.transaction_date,
      'Details': item.details,
      'Debit': parseFloat(item.debit) || 0,
      'Credit': parseFloat(item.credit) || 0,
    });
  });

  // 3. Add Totals Row
  excelData.push({
    'Post Date': 'TOTALS',
    'Value Date': '',
    'Details': '',
    'Debit': totalDebit,
    'Credit': totalCredit,
  });

  // 4. Add Closing Balance Row
  excelData.push({
    'Post Date': 'CLOSING BALANCE',
    'Value Date': '',
    'Details': '',
    'Debit': '',
    'Credit': closingBal,
  });

  // Create a worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'CashbookReport');

  // Generate Excel file buffer
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
  
  saveAs(file, `Cashbook_Report_${metaData?.start_date || 'Report'}.xlsx`);
};
    
const exportToPDF = () => {
  const dataToExport = accounts; // The transactions
  const dateInfo = inputss; // The date ranges
  
  if (!dataToExport || dataToExport.length === 0) {
    console.log("No data available to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  // --- Header Section ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  
  // Province / Admin Name
  const subTitle = province === 'undefined' ? admin : province;
  doc.text(subTitle || "", pageWidth / 2, 22, { align: "center" });

  // Date Range
  doc.setFontSize(10);
  const startDate = dateInfo?.start_date
    ? new Date(dateInfo.start_date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "--";
  const endDate = dateInfo?.end_date
    ? new Date(dateInfo.end_date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "--";

  doc.text(`Cashbook Report: ${startDate} to ${endDate}`, pageWidth / 2, 28, { align: "center" });
  
  // Account Name
  doc.setFont("helvetica", "bold");
  doc.text(`Account: ${selectedBank?.label || ""}`, pageWidth / 2, 34, { align: "center" });

  // --- Opening Balance Section ---
  const openingBalance = parseFloat(dataToExport[0]?.opening_balance || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  doc.setFontSize(11);
  doc.setTextColor(59, 130, 246); // Your blue color (#3B82F6)
  doc.text(`Opening Balance: ${openingBalance}`, 14, 42);
  doc.setTextColor(0, 0, 0); // Reset to black

  // --- Table Columns ---
  const columns = [
    { header: "Post Date", dataKey: "post_date" },
    { header: "Value Date", dataKey: "value_date" },
    { header: "Details", dataKey: "details" },
    { header: "Debit", dataKey: "debit" },
    { header: "Credit", dataKey: "credit" },
  ];

  // --- Process Rows ---
  const rows = dataToExport.map((item) => ({
    post_date: item.created_at ? new Date(item.created_at).toLocaleDateString() : "-",
    value_date: item.transaction_date || "-",
    details: item.details || "",
    debit: parseFloat(item.debit) > 0 
      ? parseFloat(item.debit).toLocaleString("en-US", { minimumFractionDigits: 2 }) 
      : "-",
    credit: parseFloat(item.credit) > 0 
      ? parseFloat(item.credit).toLocaleString("en-US", { minimumFractionDigits: 2 }) 
      : "-",
  }));

  // --- Calculate Totals ---
  const totalDebit = dataToExport.reduce((sum, item) => sum + (parseFloat(item.debit) || 0), 0);
  const totalCredit = dataToExport.reduce((sum, item) => sum + (parseFloat(item.credit) || 0), 0);
  const closingBalance = parseFloat(dataToExport[0]?.closing_balance || 0);

  // Add Totals Row
  rows.push({
    post_date: "TOTALS",
    value_date: "",
    details: "",
    debit: totalDebit.toLocaleString("en-US", { minimumFractionDigits: 2 }),
    credit: totalCredit.toLocaleString("en-US", { minimumFractionDigits: 2 }),
  });

  // Add Closing Balance Row (Visual separator handled in DidParseCell usually, but adding row is easier)
  rows.push({
    post_date: "CLOSING BALANCE",
    value_date: "",
    details: "",
    debit: "",
    credit: closingBalance.toLocaleString("en-US", { minimumFractionDigits: 2 }),
  });

  // --- Generate Table ---
  doc.autoTable({
    columns,
    body: rows,
    startY: 46,
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [0, 51, 102], textColor: 255, fontSize: 9 }, // Dark Blue Header
    columnStyles: {
      details: { cellWidth: 80 }, // Give Details column more space
      debit: { halign: "right" },
      credit: { halign: "right" },
    },
    didParseCell: (data) => {
      // Style the Totals Row
      if (data.row.raw.post_date === "TOTALS") {
        data.cell.styles.fontStyle = "bold";
        if (data.column.dataKey === "debit") data.cell.styles.textColor = [255, 0, 0]; // Red
        if (data.column.dataKey === "credit") data.cell.styles.textColor = [0, 128, 0]; // Green
      }
      // Style the Closing Balance Row
      if (data.row.raw.post_date === "CLOSING BALANCE") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [207, 217, 235]; // Light blue gradient equivalent
        if (data.column.dataKey === "credit") data.cell.styles.textColor = [22, 163, 74]; // Green for closing
      }
    },
    didDrawPage: (data) => {
      // Footer: date + page number
      const pageCount = doc.internal.getNumberOfPages();
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, pageHeight - 10);
      doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
    },
  });

  doc.save("CashbookReport.pdf");
};

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Cashbook Report</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              {userType === "Regional Accountant" && (
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Provinces:</label>
                <Select
                  onChange={handleProvinceChange}
                  options={tableData45}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200, // ✅ fixed width
                      fontSize: 14, // applies to the wrapper
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 14, // ✅ font size inside control
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 14, // ✅ selected value text
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 14, // ✅ dropdown option text
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 14, // ✅ font size in menu
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              )}

              {admin === "Continental Accountant" && (
                                <div style={{display: "flex", gap: 20}}>
                                <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Region:</label>
                                <Select
                                  onChange={handleRegionChange}
                                  options={tableData3}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 14, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>

                              <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Provinces:</label>
                                <Select
                                  onChange={handleProvinceChange}
                                  options={tableData4}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 14, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>
                              </div>
                              )}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Account:</label>
                <Select
                  onChange={handleBank}
                  options={allAccounts}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200, // ✅ fixed width
                      fontSize: 14, // applies to the wrapper
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 14, // ✅ font size inside control
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 14, // ✅ selected value text
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 14, // ✅ dropdown option text
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 14, // ✅ font size in menu
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{ fontSize: 14 }}
                  min={minDate}
                  max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  min={minDate}
                  style={{ fontSize: 14 }}
                  max={maxDate}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}

          </div>


        </div>
        <div style={{ marginTop: 24 }} />

      <div className={classes.tableContainer}>
  {accounts.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        fontSize: "18px",
        color: "#374151",
      }}
    >
      <p>No data to display</p>
    </div>
  ) : (
    <>
      <div className={classes.sideTools}>
        {accounts.length > 0 && (
          <div className={classes.filterIcons}>
            <img
              src={MailLogo}
              alt="icon1"
              className={classes.iconBtns}
              onClick={() => console.log("icon1")}
            />
            <img
              onClick={() => handlePrint()}
              src={PrintLogo}
              alt="icon2"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToExcel()}
              src={ExcelLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToPDF()}
              src={PdfLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
          </div>
        )}
      </div>

      <div className={classes.cntrTable}>
        <h1 className={classes.cntrTxt}>
          The Redeemed Christian Church Of God
        </h1>
        <p className={classes.cntrTxt12}>{province === 'undefined' ? admin : province}</p>
        <p className={classes.cntrTx122}>Cashbook Report
          between the period of {" "} {inputss?.start_date
            ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "--"} to {" "}
          {inputss?.end_date
            ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "--"}
        </p>
        <p className={classes.cntrTx122}>
          Account: {" "}{selectedBank?.label}
        </p>
      </div>

      {/* ✅ Insert the table here */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
        <thead>
          <tr style={{borderBottom: "1px solid #d1d5db",}}>
            <th
              colSpan={5}
              style={{
                textAlign: "left",
                color: "#3B82F6",
                fontWeight: 700,
                fontSize: 18,
                padding: "8px",
                 
              }}
            >
              Opening Balance
            </th>
            <th
              style={{
                textAlign: "right",
                color: "#3B82F6",
                fontWeight: 700,
                fontSize: 18,
                // padding: "8px",
                whiteSpace: "nowrap",
                textWrap:"nowrap",
                width:"100%", 
              }}
            >
              {parseFloat(accounts[0]?.opening_balance || 0).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </th>
          </tr>
          <tr style={{borderBottom: "1px solid #d1d5db",}}>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 14 }}>POST DATE</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 14 }}>VALUE DATE</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 14 }}>DETAILS</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 14 }}></th>
            <th style={{ padding: "8px", textAlign: "right", fontSize: 14 }}>DEBIT</th>
            <th style={{ padding: "8px", textAlign: "right", fontSize: 14 }}>CREDIT</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((item, index) => {
            const debit = parseFloat(item.debit) || 0;
            const credit = parseFloat(item.credit) || 0;

            return (
              <tr key={index} style={{borderBottom: "1px solid #d1d5db",}}>
                <td style={{ padding: "8px", fontSize: 14, whiteSpace: 'nowrap' }}>
                  {formatDates(item.created_at)}
                </td>
                <td style={{ padding: "8px", fontSize: 14,  whiteSpace: 'nowrap' }}>{item.transaction_date}</td>
                <td
                  style={{
                    padding: "8px",
                    maxWidth: "400px",
                    whiteSpace: "normal",
                    fontSize: 14
                  }}
                >
                  {item.details}
                </td>
                <td></td>
                <td
                  style={{
                    padding: "8px",
                    textAlign: "right",
                    color: debit > 0 ? "red" : "#111827",
                    fontSize: 14
                  }}
                >
                  {debit > 0
                    ? debit.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "--"}
                </td>
                <td
                  style={{
                    padding: "8px",
                    textAlign: "right",
                    fontSize: 14,
                    color: credit > 0 ? "green" : "#111827",
                  }}
                >
                  {credit > 0
                    ? credit.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "--"}
                </td>
              </tr>
            );
          })}

          <tr>
            <td style={{ padding: "8px", fontWeight: 700, fontSize: 14 }}>TOTALS</td>
            <td></td>
            <td></td>
            <td></td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "red",
                fontWeight: 700,
                fontSize: 14
              }}
            >
              {accounts
                .reduce(
                  (sum, item) => sum + (parseFloat(item.debit) || 0),
                  0
                )
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "green",
                fontWeight: 700,
                fontSize: 14
              }}
            >
              {accounts
                .reduce(
                  (sum, item) => sum + (parseFloat(item.credit) || 0),
                  0
                )
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </td>
          </tr>
          <tr style={{ background: `linear-gradient(#CFD9EB66, #CFD9EB)`,}}>
            <td style={{ fontSize: 14, color: 'black', fontWeight: 700, padding: 5 , whiteSpace: 'nowrap'}}>
              CLOSING BALANCE
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "#16A34A",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              {parseFloat(accounts[0]?.closing_balance || 0).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </td>
          </tr>

        </tbody>
        {/* <tfoot> */}
          
        {/* </tfoot> */}
      </table>
    </>
  )}
</div>

              </div>
       




          {savingsLoading && (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          )}

        </div>
        )
}
        export default PrintCashbook;


        {/* <div style={{ marginTop: 27 }} /> */}
        {/* {accounts?.length > 0 && (
        <div className={classes.cardContainer}>
  {(() => {
    const openingBalance = parseFloat(accounts[0]?.opening_balance || 0);

  
    let totalDebit = 0;
    let totalCredit = 0;

    accounts.forEach((item) => {
      totalDebit += parseFloat(item.debit) || 0;
      totalCredit += parseFloat(item.credit) || 0;
    });

    const closingBalance = parseFloat(accounts[0]?.closing_balance || 0);

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        labelColor: "#2563EB",
      },
      
      {
        label: "Total Debits",
        value: totalDebit,
        labelColor: "#EF4444",
      },
      {
        label: "Total Credits",
        value: totalCredit,
        labelColor: "#16A34A",
      },
      {
        label: "Closing Balance",
        value: closingBalance,
        labelColor: "#A855F7",
      },
    ];

    return stats.map((item, idx) => (
      <div className={classes.statCard} key={idx}>
       
        <h3 className={classes.cardValue}>
          <span style={{ color: item.labelColor }}>
            {item.value.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </h3>

       
        <div className={classes.cardHeader}>
          <p className={classes.cardLabel}  style={{ color: item.labelColor }}>{item.label}</p>
        </div>
      </div>
    ));
  })()}
</div>
)} */}
